import type { FormLibraryAuthProfile, FormLibrarySource } from '../../../store/types';
import { RAMCO_LOCKED_USER_INFORMATION_PROFILE_TYPES } from '../../../store/types';

export function filterUniqueRamcoAuthProfiles(authProfiles: FormLibraryAuthProfile[]): FormLibrarySource[] {
  //  The first filter removes non-Ramco auth profiles.
  //  The map reduces it down to just the auth profile types.
  //  The second filter removes duplicate auth profile types.
  return authProfiles
    .filter((p) => RAMCO_LOCKED_USER_INFORMATION_PROFILE_TYPES[p.source])
    .map((p) => p.source)
    .filter((value, index, self) => self.indexOf(value) === index);
}
